<template lang="pug">
  div
    doc-markdown(source=`
    ## Profiling Checkbox \`profiling-checkbox\`
    Intermediary wrapper between our profiling Sections and the \`sw-checkbox\` generic component. Handles styling & error management.
    `)

    doc-preview(vue=`
    .mb-3 What is Seraphin for you ? (check at least 1 option)
    profiling-checkbox(
      v-for="option in availableOptions"
      :key="option"
      v-model="chosenOptions"
      :checkbox-value="option"
      :data-purpose="option"
      :error="error"
      :label="option"
      class='w-1/4'
      @input="displayError = false"
    )
    .cursor-pointer.text-blue-500(@click="displayError = !displayError") Show errors

    <script>
      ...
      data () {
        return {
          chosenOptions: [],
          availableOptions: ['Broker', 'Angel', 'Cartoon Character'],
          displayError: false,
        };
      },
      computed: {
        error () { return this.displayError && !this.chosenOptions.length; },
      },
    </script>
    `)
      .mb-3 What is Seraphin for you ? (check at least 1 option)
      profiling-checkbox(
        v-for="option in availableOptions"
        :key="option"
        v-model="chosenOptions"
        :checkbox-value="option"
        :data-purpose="option"
        :error="error"
        :label="option"
        class='w-1/4'
        @input="displayError = false"
      )
      .cursor-pointer.text-blue-500(@click="displayError = !displayError") Show errors

    doc-markdown(source=`
    ### Properties
  | Props               | Description                                                   | Type           | Default |
  |---------------------|---------------------------------------------------------------|----------------|---------|
  | \`value\` (v-model) | Array of chosen values to which the checkboxes are binded.    | Array          | -       |
  | \`checkbox-value\`  | Value of specific checkbox item.                              | String         | -       |
  | \`error\`           | Whether the red error highlighting should be displayed or not.| Boolean        | false   |
  | \`label\`           | Label of specific checkbox item.                              | String         | -       |
    `)

    doc-markdown(source=`
    ### Events
  | Event name | Description                   | Parameters             | Usage      |
  |------------|-------------------------------|:----------------------:|------------|
  | input      | Triggered when item checked   | Array of chosen items  | \`@input\` |
    `)
</template>

<script>
export default {
  data () {
    return {
      chosenOptions: [],
      availableOptions: ['Broker', 'Angel', 'Cartoon Character'],
      displayError: false,
    };
  },
  computed: {
    error () { return this.displayError && !this.chosenOptions.length; },
  },
};
</script>
